import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Avatar, AvatarGroup, Button, HStack, SkeletonCircle, Stack, Text, VStack } from '@chakra-ui/react'
import { usePin, useShareVehicle, useVehicles } from 'context'
import { isEmpty } from 'lodash'
import { primaryColor } from 'theme/foundations/primaryColor'

import InfoButton from 'components/InfoButton'
import { ChevronRightIcon } from 'components/SVGS'


export const ShareVehicleInfo = () => {
  const navigation = useNavigate()
  const {
    shareVehicleState: {
      loading,
      state: { contactsShareVehicles },
    },
  } = useShareVehicle()
  const { pinState: { state: { isHavePin } } } = usePin()
  const { vehicleState: { state: { vehicle } } } = useVehicles()
  const {
    icon: { secondaryIconColor },
    text: { bgColorSecondaryText },
    pressable: { gradientColor: { gradientOne, gradientTwo } }
  } = primaryColor

  const handleShareVehicle = () => {
    if (!isHavePin)
      navigation('/create-pin')
    else if (contactsShareVehicles.length < 4)
      navigation('/confirm-to-pin', {
        state: {
          params: {
            previousRoute: 'VEHICLE',
            text: 'Para compartir tu vehículo debes ingresar tu PIN',
            textButton: 'Ingresar',
            vehicleInfo: vehicle,
          }
        }
      })
  }

  return (
    <VStack w='full' spacing={5} h='full'>
      {loading ?
        <AvatarGroup max={4}>
          {Array(4).fill(null).map((_, index) =>
            <SkeletonCircle key={index.toString()} />
          )}
        </AvatarGroup>
        :
        <VStack w={'90%'}>
          <HStack w={'full'} justifyContent={'center'}>
            <Stack w={'90%'}>
              <Text variant={'SM'} textAlign={'center'}>
                {!isEmpty(contactsShareVehicles) ?
                  'Estas compartiendo este vehículo con:'
                  : 'No estás compartiendo este vehículo'}
              </Text>
            </Stack>
            <InfoButton placement='bottom-end' popoverText='Solo podrás compartir tu auto con 4 personas' />
          </HStack>
          {!isEmpty(contactsShareVehicles) ?
            <HStack alignItems={'center'} justifyContent={'center'} w={'full'}>
              <AvatarGroup max={4}>
                {contactsShareVehicles.map(contact => (
                  <Avatar
                    key={contact.id}
                    color={bgColorSecondaryText}
                    bgGradient={`linear(to-br, ${gradientOne}, ${gradientTwo})`}
                    name={contact.email}
                    size="md" />
                ))}
              </AvatarGroup>
              <Button
                onClick={() => navigation('/detail-share-vehicle')}
                rightIcon={<ChevronRightIcon
                  fill={secondaryIconColor} />}
              >
                VER DETALLE
              </Button>
            </HStack>
            :
            <Button w={'full'} variant={'secondary'} onClick={handleShareVehicle}>
              Compartir
            </Button>
          }
        </VStack>
      }

    </VStack>
  )
}
